export default {
  setConstructions(state, constructions) {
    state.constructions = constructions;
  },
  setTeams(state, teams) {
    state.teams = teams;
  },
  setPosts(state, posts) {
    state.posts = posts;
  },
};
